(ns ycweb.app.website.footer.footernav
  (:require
   [rum.core :as rum]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as u]))

(rum/defc footernav < rum/reactive [app-atom {:keys [pagetype]}]
  [:div
   {:class (u/bem :yc-section [:standard-underline])}
   [:div.flex-grid-group
    [:div.footer-nav
     {:class (u/bem :flex-grid-block [:ml-1-3])}
     [:div.flex-grid-content.js-footer-nav
      [:h3.footer-nav-heading.js-footer-nav-heading
       [:a.footer-nav-heading__link.js-footer-nav-toggle-link
        {:href "#"}
        [:span.footer-nav-heading__text "Shop"]
        [:i.footer-nav-heading__icon.js-footer-nav-heading-icon
         {:class (u/bem :icon [:plus :is-dark :block])}]]]
      [:ul.footer-nav-list.js-footer-nav-list
       {:role "directory"}
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/index.htm?ref=footerlink"}
         "Shop online"]]
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/store-directory.htm?ref=footerlink"}
         "Store locator"]]
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/gifting.htm?ref=footerlink"}
         "Gifts & vouchers"]]
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/registry.htm?ref=footerlink"}
         "Wedding registry"]]]]]
    [:div.footer-nav
     {:class (u/bem :flex-grid-block [:ml-1-3])}
     [:div.flex-grid-content.js-footer-nav
      [:h3.footer-nav-heading.js-footer-nav-heading
       [:a.footer-nav-heading__link.js-footer-nav-toggle-link
        {:href "#"}
        [:span.footer-nav-heading__text "Company"]
        [:i.footer-nav-heading__icon.js-footer-nav-heading-icon
         {:class (u/bem :icon [:plus :is-dark :block])}]]]
      [:ul.footer-nav-list.js-footer-nav-list
       {:role "directory"}
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/about-us.htm?ref=footerlink"}
         "About us"]]
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/jobs.htm?ref=footerlink"}
         "Careers"]]
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/help.htm?action=category&id=21&name=Legal"}
         "Legal & privacy policy"]]
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/help.htm?action=article&id=155&ref=footerlink"}
         "Returns & repairs policy"]]]]]
    [:div.footer-nav
     {:class (u/bem :flex-grid-block [:ml-1-3])}
     [:div.flex-grid-content.js-footer-nav
      [:h3.footer-nav-heading.js-footer-nav-heading
       [:a.footer-nav-heading__link.js-footer-nav-toggle-link
        {:href "#"}
        [:span.footer-nav-heading__text "Need help?"]
        [:i.footer-nav-heading__icon.js-footer-nav-heading-icon
         {:class (u/bem :icon [:plus :is-dark :block])}]]]
      [:ul.footer-nav-list.js-footer-nav-list
       {:role "directory"}
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/help.htm?ref=footerlink"}
         "Help centre"]]
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/help.htm?ref=footerlink"}
         "Contact us"]]
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/myaccount.htm?action=track"}
         "Track your order"]]
       [:li.footer-nav-list__item
        [:a.footer-nav-list__link
         {:href "/myaccount.htm?action=aftersales"}
         "Returns & repairs"]]]]]]])